//
//
//
//
//
//
//
//
//

import store from '../store';
import ModuleContainer from './ModuleContainer';
import Pagination from '../libs/PostPagination';

export default {
    data() {
        return {
            store,
        };
    },
    components: {
        ModuleContainer,
        Pagination
    },
    computed: {
        animation() {
            return this.$variables.post_animation_style != '' ? this.$variables.post_animation_style + ' animate__animated wfit' : ''
        },
        page() {
            return this.store.state.page - 1
        },
        pages() {
            return this.store.state.pages;
        },
        blocks() {
            return this.store.state.blocks;
        },
        currentLanguge() {
            return this.store.state.currentLanguge;
        },
        has_pagination() {
            return this.$variables.post_pagination && this.store.state.total_pages > 1
        }
    },
    beforeMount() {
        if (this.blocks) {
            this.updateCounter(this.blocks)
            this.changePage(this.page)
        }
    },
    created() {
        this.store.state.vm = this;
    },
    mounted() {
        this.$quizierEvent.onInit();
    },
    methods: {
        changePage(page) {
            this.store.state.blocks = JSON.parse(JSON.stringify(this.pages[page]))
        },
        updateCounter(blocks) {
            const locale = this.store.state.currentLanguge;
            let counter = 1;
            blocks.forEach(function (block, index) {
                const block_type = typeof block.contents[locale]['data'].block_type !== 'undefined' ? block.contents[locale]['data'].block_type : false;
                if (block_type == 'list' || block_type == 'rank') {
                    block.contents[locale]['data'].counter = counter
                    counter++;
                }
            });
        }
    },
    watch: {
        page: function(page, o) {
            this.changePage(page)
            Quizier.initSocial()
        }
    },
};
